import styled from 'styled-components';
export const WrapperReceipt = styled.div`
  .page {
    position: relative;
    background: white;
    display: block;
    margin: 0 auto;
    margin-bottom: 0.5cm;
    box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
    width: 21cm;
    height: 29.7cm;
    page-break-after: always;
  }
  .flex {
    display: flex;
  }
  .flex-column {
    flex-direction: column;
  }
  .flex-1 {
    flex: 1;
  }
  .justify-content-between {
    justify-content: space-between;
  }
  .align-items-center {
    align-items: center;
  }
  .w-100 {
    width: 100%;
  }
  .label {
    margin-left: 5px;
  }
  .bold {
    font-weight: bold;
  }

  .logo-box {
    width: 155px;
    padding: 38px 0;

    img {
      width: 100%;
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .card-a {
    margin-bottom: 10px;
    border: 1px solid #ddd;
    border-radius: 15px;
    &_box {
      display: flex;
      padding: 10px;
    }
    &_item {
      flex: 1;
      text-align: center;
      border-right: 1px dashed #ddd;
      &:first-child {
        border-right: none;
      }
    }
    &_label {
      color: #ccc;
    }
    &_text {
      font-weight: bold;
    }
  }
  .card-b {
    &_box {
      display: flex;
      flex-direction: column;
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 15px;
    }

    &_header {
      display: flex;
      flex: 1;
      &-box {
        padding: 0 0 5px 0;
        border-bottom: 2px solid #ddd;
        margin-bottom: 5px;
      }
      &-item {
        flex: 1;
        text-align: center;
        border-right: 1px dashed #ddd;
        font-size: 0.675rem;
        padding: 5px 0;
        &:first-child {
          border-right: none;
        }
        &:nth-child(2) {
          flex: 5;
        }
        &:nth-child(4) {
          flex: 2;
        }
        &:last-child {
          flex: 2;
        }
      }
    }
    &_content {
      display: flex;
      flex: 1;
      flex-direction: column;
      &-row {
        display: flex;
        flex: 1;
        margin: 3px 0;
        padding: 3px 0;
        border-bottom: 1px solid #ddd;
        &:last-child {
          border-bottom: none;
          margin: 0;
        }
      }
      &-item {
        flex: 1;
        text-align: center;
        border-right: 1px dashed #ddd;
        padding: 5px 0;
        font-size: 0.675rem;
        &:first-child {
          border-right: none;
        }
        &:nth-child(2) {
          flex: 5;
        }
        &:nth-child(4) {
          flex: 2;
        }
        &:last-child {
          flex: 2;
        }
      }
    }
  }

  .description {
    min-height: 50px;
    border: 2px solid #ddd;
    border-radius: 15px;
  }
  .sing-box {
    display: flex;
    justify-content: space-between;
    padding: 20px 20px;
    bottom: 0;
    left: 0;
    right: 0;
    .item {
      display: flex;
      flex-direction: column;
    }
  }

  @media print {
    body {
      width: 21cm;
      height: 25.5cm;
      margin: 30mm 45mm 30mm 45mm;
      /* change the margins as you want them to be. */
    }
    .page {
      width: 20cm;
      height: 25.5cm;
      margin-right: -20px;
      page-break-after: always;
    }
  }
`;
